import React from "react";
import type { ViewComponent } from "@frui.ts/views";
import { registerView } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import DomesticRefundsViewModel from "viewModels/finance/refundApprovals/transferRefunds/domesticRefunds/domesticRefundsViewModel";
import TransferRefundsView from "../transferRefundsView";

const DomesticRefundsView: ViewComponent<DomesticRefundsViewModel> = observer(({ vm }) => (
  <TransferRefundsView key={vm.name} vm={vm} />
));

registerView(DomesticRefundsView, DomesticRefundsViewModel);
